<template>
    <transition name="fade">
        <div v-if="isShow" class="selector-roll" :class="{ active: isShow }" @touchstart.prevent="close">
            <!-- 城市选择组件外的遮罩层 box-shadow代替-->
            <div class="sel-area" @touchstart.stop>
                <span class="icon-close" @click.prevent="close"></span>
                <slot />
                <div class="btn-slot" @click.prevent.stop="confirm">
                    <slot name="button" :active="enableBtn">
                        <!-- 默认的确认按钮 -->
                        <div class="btn-confirm" :class="{ active: enableBtn }">确认</div>
                    </slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        isShow: {
            // 是否显示该组件
            type: Boolean
        },
        enableBtn: {
            // 底部区域是否能被点击
            type: Boolean
        },
        finished: {
            // 点击了底部按钮区域
            type: Boolean
        },
        hasValid: {
            type: Boolean, // 是否有窗体内容部分的验证规则
            default: false
        },
        cbValid: {
            // 内容部分规则验证函数
            type: Function
        }
    },
    watch: {
        isShow(val) {
            if (val) {
                this.$emit('update:finished', false)
                this.$emit('update:enableBtn', false)
            }
        }
    },
    methods: {
        close() {
            // 关闭窗体
            this.$emit('update:isShow', false)
        },
        async confirm() {
            if (!this.enableBtn) {
                return
            }
            if (this.hasValid) {
                // 若有验证规则， 这根据回调函数的验证结果来显示窗体
                this.$emit('update:finished', true)
                const valid = await this.cbValid()
                if (valid) {
                    this.close()
                }
            } else {
                this.$emit('update:finished', true)
                this.close()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.selector-roll {
    position: absolute;
    z-index: 20;
    width: 100%;
    left: 50%;
    top: 0;
    bottom: 0;
    max-width: 7.5rem;
    transform: translateX(-50%);
    color: #000;
    display: flex;
    .sel-area {
        position: absolute;
        bottom: 0rem;
        width: 100%;
        min-height: 5rem;
        flex: 1;
        display: flex;
        flex-flow: column nowrap;
        background: #fff;
        box-shadow: 0 0 9999px 6rem rgba(0, 0, 0, 0.3);
        border-radius: 0.08rem 0.08rem 0 0;
        .icon-close {
            position: absolute;
            top: 0.2rem;
            right: 0.5rem;
            width: 0.5rem;
            height: 0.5rem;
            &:before {
                position: absolute;
                top: 50%;
                content: '';
                display: block;
                height: 5px;
                width: 0.36rem;
                background: #000;
                transform: rotate(45deg);
            }
            &:after {
                position: absolute;
                top: 50%;
                content: '';
                display: block;
                height: 5px;
                width: 0.36rem;
                background: #000;
                transform: rotate(-45deg);
            }
        }
    }
    .btn-confirm {
        color: #fff;
        line-height: 1rem;
        font-weight: bold;
        letter-spacing: 0.5rem;
        text-indent: 0.5rem;
        text-align: center;
        background: rgba(0, 0, 0, 0.3);
        &.active {
            background: rgba(0, 0, 0, 0.2);
        }
    }
}
::-webkit-scrollbar {
    display: none;
}
.fade-enter-active,
.fade-leave-active {
    bottom: 0;
    opacity: 1;
    transition: all 0.3s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
    bottom: -100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/citySelector/overlay/index.vue